import { rest } from 'msw';

import { getConfig } from 'shared/config';

import {
  broadbandMenuDetails,
  broadbandSubscription,
  officeLicenseURL,
  subscribableSecurityPackages,
  subscriptionHybrid,
  wiFiBoosterEligibilityForOrder,
  wiFiSettings,
} from '.';
import { UpdateWiFiSettingsDTO } from '../types';

const odinAPI = getConfig().odin?.host;

export const handlers = [
  rest.get(`${odinAPI}/yousee/selfcare/products/MOCK_BROADBAND/menu-details`, (req, res, ctx) =>
    res(ctx.json(broadbandMenuDetails)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/subscriptions/MOCK_BROADBAND`, (req, res, ctx) =>
    res(ctx.json(broadbandSubscription)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/broadband/:subscriptionId/hybrid`, (req, res, ctx) =>
    res(ctx.json(subscriptionHybrid)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/broadband/:subscriptionId/wifi/settings`, (req, res, ctx) =>
    res(ctx.json(wiFiSettings)),
  ),
  rest.post(
    `${odinAPI}/yousee/selfcare/broadband/:subscriptionId/wifi/settings`,
    (req, res, ctx) =>
      res(
        ctx.json({
          ...wiFiSettings,
          ...(req.body as UpdateWiFiSettingsDTO),
        }),
      ),
  ),
  rest.post(
    `${odinAPI}/yousee/selfcare/broadband/:subscriptionId/wifi/settings/optimize`,
    (req, res, ctx) => res(ctx.json(wiFiSettings)),
  ),
  rest.get(
    `${odinAPI}/yousee/selfcare/broadband/extender/:subscriptionId/isEligibleForOrder`,
    (req, res, ctx) => res(ctx.json(wiFiBoosterEligibilityForOrder)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/office/:subscriptionId/license`, (req, res, ctx) =>
    res(ctx.json(officeLicenseURL)),
  ),
  rest.get(
    `${odinAPI}/yousee/selfcare/subscriptions/:subscriptionId/subscribable-securitypackages`,
    (req, res, ctx) => res(ctx.json(subscribableSecurityPackages)),
  ),
];
